import { MonitorStatus } from '@fe/core';
import { useState } from 'react';
import { GetThresholdsForFlightResponse, MessageType } from '../../services/actor-messages';
import { AircraftThresholdType, ThresholdLevel, ThresholdLevelActionType } from '../../types/thresholds';
import { useAppSelector } from './store-hooks';
import { useFlightWorker } from './use-flight-worker';
import { useSafeEffect } from './use-safe-effect';

export function useFlightThresholds(id: number): GetThresholdsForFlightResponse | null {
    const lastUpdateTime = useAppSelector((x) => x.global.flightWorker.lastUpdate);
    const [thresholds, setThresholds] = useState<GetThresholdsForFlightResponse | null>(null);
    const worker = useFlightWorker();

    useSafeEffect(() => {
        // Tutorial
        if (id === -1) {
            setThresholds({
                thresholds: [
                    {
                        type: AircraftThresholdType.aptMonStatDst,
                        monitorStatus: MonitorStatus.critical,
                        actualValue: 'Warning',
                        breachedLevel: {
                            repeat: false,
                            triggerOnImproving: false,
                            rawValue: 0,
                            commonUnitValue: 0,
                            unitIndex: null,
                            actionType: ThresholdLevelActionType.none,
                            actionTimeMinutes: null,
                            level: ThresholdLevel.info
                        }
                    }
                ],
                airports: {
                    origin: null,
                    destination: {
                        id: 'JFK',
                        iata: 'JFK',
                        icao: 'KJFK',
                        faa: 'JFK',
                        name: 'JFK'
                    },
                    alternates: []
                }
            });
        } else {
            worker.actor.sendAsync({ type: MessageType.getThresholdsForFlight, data: id }).then(setThresholds);
        }
    }, [worker, id, lastUpdateTime]);

    return thresholds;
}
